import { Injectable } from '@angular/core';

// Services
import { NavigationParam, ServiceBase } from '../service-base';

const CLASS_NAME = 'BankAccountLineType';
const ENDPOINT = `/bank-account-line-types/`;
const NAVIGATIONS: NavigationParam[] = [
    { key: 'accounts', path: 'accounts/', childClass: 'Account' },
]

@Injectable({
    providedIn: 'root'
})
export class BankAccountLineTypeService extends ServiceBase {

    // Pas de cache : la liste est un référentiel, mais la navigation `accounts` est
    // filtrée sur le dossier côté back — et `getRelated$` passe par `getList$`, donc
    // par le cache. Il resservirait le plan comptable du dossier précédent (#173).

    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addNavigations(NAVIGATIONS);
    }
}
